import { ChangeDetectionStrategy, Component, DestroyRef, inject, ViewEncapsulation, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { emailValidator } from '../../common/validators/form.validator';
import { UserService } from '../../services/user.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoadingService } from '../../services/loader.service';
import { User } from '../../common/interfaces/user.interface';
import { ToastrService } from 'ngx-toastr';
import { SeoService } from '../../services/meta.service';
@Component({
  selector: 'wire-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {

  private readonly userService = inject(UserService);
  private readonly loadingService = inject(LoadingService);
  private readonly toastr = inject(ToastrService);
  private readonly seoService = inject(SeoService);
  public router = inject(Router);
  public destroyRef = inject(DestroyRef);
  private readonly route = inject(ActivatedRoute);
  public cdr = inject(ChangeDetectorRef);

  public loading = false;
  isConfirmed = false
  public form = new UntypedFormGroup({
    email: new UntypedFormControl(null, [Validators.required, emailValidator]),
    password: new UntypedFormControl(null, [Validators.required, Validators.minLength(6)]),
  });

  public showPassword = false;


  ngOnInit(): void {

    this.seoService.setMetaTags({
      title: 'Wire Festival | Login',
      description: 'Wire Festival Login',
      keywords: 'Wire Festival Login'
    });

    if (this.route.snapshot.queryParams['code']) {
      this.userService.confirmEmail(this.route.snapshot.queryParams['code'])
        .subscribe({
          next: (response: any) => {
            if (response?.access_token && response?.user) {
              this.loadingService.show();
              setTimeout(() => this.loadingService.hide(), 3000);
              this.updateUserEvents();
              if (response.user.isProfileCompleted) {
                this.router.navigate(['/profile/details']);
              } else {
                this.router.navigate(['/profile/user/personal']);
              }
            } else {
              this.isConfirmed = true;
              this.cdr.detectChanges();
            }
          },
          error: (error) => {
            console.error('Email confirmation failed:', error);
          }
        });
    }
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  login(): void {
    this.loading = true;
    this.userService.login(
      this.form.value.email,
      this.form.value.password)
      .pipe(
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: (response: { access_token: string, user: User }) => {
          this.loading = false;
          if (response.access_token && response.user) {
            this.loadingService.show();
            setTimeout(() => this.loadingService.hide(), 3000);
            this.updateUserEvents();

            // Get return URL from route parameters or default to profile page
            const returnUrl = this.route.snapshot.queryParams['redirect'] || '/profile/details';

            // Navigate based on profile completion status
            if (response.user.isProfileCompleted) {
              this.router.navigate([returnUrl]);
            } else {
              this.router.navigate(['/profile/user/personal']);
            }

            this.cdr.detectChanges();
          }
        },
        error: (error) => {
          this.loading = false;
          this.toastr.error(error.error.message);
          this.cdr.detectChanges();
        }
      });
  }


  updateUserEvents() {
    this.userService.getMyGoings().subscribe();
  }
}
